import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { useFavorites } from "@/hooks/useFavorites";
import { animeList } from "@/mocks/anime";

export default function FavoritesStrip() {
  const { favorites } = useFavorites();
  const list = favorites
    .map((id) => animeList.find((a) => a.id === id))
    .filter((a): a is (typeof animeList)[number] => Boolean(a));

  return (
    <section className="w-full rounded-lg bg-secondary-50 border border-secondary-100 p-5 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center text-lg">
            <i className="ri-heart-3-line"></i>
          </span>
          <div>
            <h2 className="text-base md:text-lg font-bold text-foreground-950">我的收藏夹</h2>
            <p className="text-xs text-foreground-600">收藏会保存在本地，刷新页面依然保留</p>
          </div>
        </div>
        {list.length > 0 && (
          <span className="text-xs text-foreground-600 whitespace-nowrap">
            共 {list.length} 部
          </span>
        )}
      </div>

      {list.length === 0 ? (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-2">
          <p className="text-sm text-foreground-600 text-center sm:text-left">
            还没有收藏任何动漫，去详情页点击「收藏」按钮，把喜欢的作品收进来吧。
          </p>
          <Link
            to="/category"
            className="px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            去逛逛动漫
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {list.slice(0, 6).map((anime) => (
            <AnimeCard key={anime.id} anime={anime} showDescription={false} />
          ))}
        </div>
      )}
    </section>
  );
}